import React from 'react'
import classNames from 'classnames'
import { sparkBaseClassName, sparkClassName } from 'react-spark/src/util'

class NovaToggleContent extends React.Component {
  getSizeClassName() {
    const { size } = this.props
    
    switch (size) {
      case 'small':
        return sparkBaseClassName('TypeBodyFour')
      case 'large':
        return sparkBaseClassName('TypeBodyTwo')
      case 'medium':
      default:
        return sparkBaseClassName('TypeBodyThree')
    }
  }

  get className() {
    const {className} = this.props

    return classNames(
      this.getSizeClassName(),
      sparkClassName('utility', 'pts'),
      sparkClassName('utility', 'pbs'),
      {[className]: className}
    )
  }

  render = () => {
    const {children, className, size, isOpen, iconPosition, ...props} = this.props

    return (
      <div 
        data-sprk-toggle='content'
        style={{ display: isOpen ? 'block' : 'none' }}
      >
        <div className={this.className} {...props}>{children}</div>
      </div>
    )
  }
}

export default NovaToggleContent
